class HomeLastVideo extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-homelastvideo-track]');
    this.slides = this.querySelectorAll('[data-homelastvideo-slide]');
    this.dots = this.querySelectorAll('[data-homelastvideo-dot]');
    this.mobileScrollEnabled = this.dataset.mobileScroll === 'true';

    if (!this.track || !this.slides.length) return;

    this.onScroll = this.handleScroll.bind(this);
    this.track.addEventListener('scroll', this.onScroll, { passive: true });

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.scrollToSlide(index));
    });

    this.observeVideos();
    this.handleScroll();
  }

  disconnectedCallback() {
    if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    if (this.observer) this.observer.disconnect();
  }

  handleScroll() {
    if (!this.mobileScrollEnabled || window.innerWidth >= 750) return;

    const trackRect = this.track.getBoundingClientRect();
    const trackCenter = trackRect.left + trackRect.width / 2;
    let activeIndex = 0;
    let smallestDistance = Infinity;

    this.slides.forEach((slide, index) => {
      const slideRect = slide.getBoundingClientRect();
      const slideCenter = slideRect.left + slideRect.width / 2;
      const distance = Math.abs(slideCenter - trackCenter);

      if (distance < smallestDistance) {
        smallestDistance = distance;
        activeIndex = index;
      }
    });

    this.dots.forEach((dot, index) => {
      dot.classList.toggle('is-active', index === activeIndex);
      dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false');
    });
  }

  scrollToSlide(index) {
    const slide = this.slides[index];
    if (!slide) return;

    this.track.scrollTo({
      left: slide.offsetLeft,
      behavior: 'smooth',
    });
  }

  observeVideos() {
    const videos = this.querySelectorAll('video.homelastvideo__video');
    if (!videos.length) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (!(video instanceof HTMLVideoElement)) return;

          if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.55 }
    );

    videos.forEach((video) => this.observer.observe(video));
  }
}

if (!customElements.get('home-last-video')) {
  customElements.define('home-last-video', HomeLastVideo);
}
